import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ACTION_LABEL_KEYS = {
  view: "View",
  create: "Create",
  update: "Update",
  delete: "Delete"
};

const ApiFormHeader = ({ action, modelLabel, modelName }) => {
  const { t } = useTranslation("common");
  const actionKey = (action || "view").toLowerCase();
  const actionLabel = ACTION_LABEL_KEYS[actionKey] || action;

  return (
    <div className="form-view-title">
      <span className={`action-badge ${actionKey}`}>{t(actionLabel)}</span>
      <span>
        {modelLabel || modelName}
        {modelName && modelLabel && modelLabel !== modelName ? (
          <span style={{ color: "var(--text-muted)", fontWeight: 600 }}>
            {" "}
            ({modelName})
          </span>
        ) : null}
      </span>
    </div>
  );
};

ApiFormHeader.propTypes = {
  action: PropTypes.string.isRequired,
  modelLabel: PropTypes.string,
  modelName: PropTypes.string
};

ApiFormHeader.defaultProps = {
  modelLabel: "",
  modelName: ""
};

export default ApiFormHeader;
